import axios from 'axios'
import getQueryObject from '@/utils/get-query-object'
import getErrorMessage from '@/utils/get-error-message'

export default async function () {
  try {
    const { data } = await axios.get('/api/auth/login')
    if (Boolean(data?._id)) {
      const queries = getQueryObject()
      window.location.replace(queries.redirect || '/home')
    }
  } catch (e: any) {
    getErrorMessage(e)
  }
}
